/**
 * 电商套图 · 应用内浅色 + 金色点缀设计 token。
 *
 * 与平台整体浅色风格统一（白底卡片 / slate 描边 / 金色主操作），
 * 只约束应用内容区，不影响平台外壳与其他应用。
 */

export const suiteTheme = {
  /** 应用主区背景（阶段工作台底色） */
  pageBg: 'bg-[#eef3f8] text-zinc-800',
  /** 项目列表 hero 浅色底 */
  heroBg: 'bg-gradient-to-br from-sky-50 via-white to-slate-50',

  /** 卡片容器 */
  card: 'rounded-2xl border border-slate-200 bg-white',
  cardHover: 'transition hover:border-blue-300/70',

  /** 左侧设置栏折叠区块 */
  sidebarSection: 'rounded-2xl border border-slate-200 bg-white',
  sidebarHeader: 'flex w-full items-center justify-between px-4 py-3 text-left text-sm font-medium text-zinc-700',

  /** 表单 */
  label: 'mb-1.5 block text-xs font-medium text-zinc-500',
  input:
    'w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-zinc-800 placeholder:text-zinc-400 outline-none transition focus:border-blue-400',
  textarea:
    'w-full resize-y rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm leading-relaxed text-zinc-800 placeholder:text-zinc-400 outline-none transition focus:border-blue-400',
  select: 'w-full appearance-none rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-zinc-800 outline-none transition focus:border-blue-400',

  /** 按钮 */
  primaryBtn:
    'inline-flex items-center justify-center gap-2 rounded-xl bg-blue-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-600 disabled:cursor-not-allowed disabled:opacity-40',
  darkBtn:
    'inline-flex items-center justify-center gap-2 rounded-xl bg-zinc-800 px-4 py-2 text-sm font-semibold text-zinc-50 transition hover:bg-zinc-700 disabled:cursor-not-allowed disabled:opacity-40',
  ghostBtn:
    'inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-transparent px-4 py-2 text-sm font-medium text-zinc-600 transition hover:border-blue-300 hover:text-blue-700 disabled:cursor-not-allowed disabled:opacity-40',
  dangerText: 'text-rose-500 transition hover:text-rose-600',

  /** 徽标 */
  badgeGold: 'inline-flex items-center gap-1 rounded-full border border-blue-300/60 bg-sky-100 px-2.5 py-0.5 text-xs font-medium text-sky-700',
  badgeMuted: 'inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-100 px-2.5 py-0.5 text-xs text-zinc-500',
  badgeSuccess: 'inline-flex items-center gap-1 rounded-full border border-emerald-300/60 bg-emerald-100 px-2.5 py-0.5 text-xs text-emerald-700',
  badgeDanger: 'inline-flex items-center gap-1 rounded-full border border-rose-300/60 bg-rose-100 px-2.5 py-0.5 text-xs text-rose-700',

  /** 顶部阶段条 */
  stageBar: 'flex flex-1 items-stretch overflow-hidden rounded-2xl border border-slate-200 bg-white',
  stageItem: 'flex flex-1 items-center justify-center gap-2 px-4 py-3 text-sm font-medium transition',
  stageItemActive: 'bg-blue-100 text-blue-700',
  stageItemInactive: 'text-zinc-500 hover:text-zinc-700',

  /** 规划流式输出预览 */
  streamPreview: 'max-h-40 overflow-y-auto whitespace-pre-wrap break-all font-mono text-xs leading-relaxed text-zinc-600',
} as const;
